<div class="notify-MainBanner" *ngIf="showReleaseNoteBanner">
    <div class="notify-banner">
        <img src="assets/NewRelease.JPG" class="img-margin" />
        Research Credit Navigator has a new release! &nbsp; <button class="notify-button" (click)="downloadReleaseNotes()"> <b> What's new? </b> </button>
        <button class="cross-icon" (click)="hideBanner()"> </button>
    </div>
    </div>
